// START SECTION FOR READ MORE TOGGLE BUTTON

// We have to listen for turbo links instead of DOMContentLoaded now because
// we're using turbo link partials, see more info: https://stackoverflow.com/questions/73168578/rails-js-script-code-not-working-while-screen-back-due-to-turbolinks

document.addEventListener('turbo:load', function () {
  console.log('Custom JS in Entrypoints connected!');

  // Lightbox Controls
  const lightbox = document.getElementById('lightbox');
  const lightboxVideo = document.getElementById('lightbox-video');
  const lightboxClose = document.getElementsByClassName('lightbox-close')[0];

  document.querySelectorAll('.open-lightbox').forEach((element) => {
    element.addEventListener('click', function (event) {
      console.log('Open lightbox clicked');
      event.preventDefault();
      const videoUrl = this.getAttribute('data-video-url');
      lightboxVideo.src = videoUrl;
      lightbox.style.setProperty('display', 'flex', 'important'); // Show the lightbox
    });
  });

  if (lightboxClose) {
    lightboxClose.addEventListener('click', function () {
      lightbox.style.setProperty('display', 'none', 'important'); // Hide the lightbox
      lightboxVideo.src = ''; // Stop the video
    });
  }

  window.addEventListener('click', function (event) {
    if (event.target == lightbox) {
      lightbox.style.setProperty('display', 'none', 'important'); // Hide the lightbox
      lightboxVideo.src = ''; // Stop the video
    }
  });
  // End Lightbox Controls

  document.addEventListener('click', function (event) {
    if (event.target.matches('.toggle-btn')) {
      var btn = event.target;
      var descriptionText = document.querySelectorAll('.description-text');

      descriptionText.forEach(function (text) {
        text.classList.toggle('expanded');
        if (text.classList.contains('expanded')) {
          btn.textContent = 'Show less...';
        } else {
          btn.textContent = 'Read more...';
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }
  });

  var menuToggle = document.getElementById('menu-toggle');
  var menuItems = document.getElementById('menu-items');

  // Function to toggle menu
  function toggleMenu() {
    menuItems.classList.toggle('visible');
  }

  // Listen for click on toggle button
  if (menuToggle) {
    menuToggle.addEventListener('click', function (event) {
      toggleMenu();
      event.stopPropagation(); // Prevent click from immediately propagating to document
    });
  }

  // Function to close menu if clicking outside of it
  function handleClickOutside(event) {
    if (
      !menuItems.contains(event.target) &&
      !menuToggle.contains(event.target) &&
      menuItems.classList.contains('visible')
    ) {
      menuItems.classList.remove('visible');
    }
  }

  // Listen for clicks outside of menu
  document.addEventListener('click', handleClickOutside);

  // END SECTION FOR READ MORE TOGGLE BUTTON

  // START SECTION FOR COUNTRY COUNTER

  const cityDiv = document.getElementById('cityDivCanada');
  const countryCountElement = document.getElementById('countryCountCanada');

  // Check if the necessary elements exist on the current page
  if (cityDiv && countryCountElement) {
    // Update the count initially
    updateCountryCount();

    // Function to update the count whenever the city div changes
    function updateCountryCount() {
      const numberOfCities = cityDiv.children.length;
      countryCountElement.textContent = `🇨🇦 Canada (${numberOfCities})`;
    }
    // Call the function to update the count after adding or removing cities
    updateCountryCount();
  }

  // END SECTION FOR COUNTRY COUNTER

  // START SECTION FOR BOOTSTRAP COLLAPSE

  function setupButtonToggle(buttonId, dataId) {
    var button = document.getElementById(buttonId);
    var collapseExample = document.getElementById(dataId);

    if (button && collapseExample) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        var isExpanded = collapseExample.classList.contains('show');

        if (isExpanded) {
          collapseExample.classList.remove('show');
        } else {
          collapseExample.classList.add('show');
        }
      });
    }
  }

  setupButtonToggle('more-info-button', 'more-info-data');
  setupButtonToggle('event-info-button', 'event-info-data');
  setupButtonToggle('artist-info-button', 'artist-info-data');
  setupButtonToggle('recurringEventButton', 'recurringEventData');

  // END SECTION FOR BOOTSTRAP COLLAPSE

  // START SECTION FOR DROPDOWN TOOLTIPS

  var dropdownItems = document.querySelectorAll('.dropdown-item');
  var showTimer, hideTimer;

  dropdownItems.forEach(function (dropdownItem) {
    dropdownItem.addEventListener('keydown', function (event) {
      var next;
      if (event.key === 'ArrowDown') {
        next = dropdownItem.nextElementSibling;
        if (next) {
          next.focus();
        }
      } else if (event.key === 'ArrowUp') {
        next = dropdownItem.previousElementSibling;
        if (next) {
          next.focus();
        }
      }
    });
  });

  function handleDropdownHoverAndKeyboard(element) {
    var dropdownMenu = element.querySelector('.dropdown-menu');
    element.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
      var otherDropdownMenus = document.querySelectorAll('.dropdown-menu:not(.show)');
      otherDropdownMenus.forEach(function (menu) {
        menu.style.display = 'none';
      });
      showTimer = setTimeout(function () {
        dropdownMenu.style.display = 'block';
      }, 250);
    });
    element.addEventListener('mouseleave', function () {
      clearTimeout(showTimer);
      hideTimer = setTimeout(function () {
        dropdownMenu.style.display = 'none';
      }, 250);
    });
    element.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        clearTimeout(showTimer);
        clearTimeout(hideTimer);
        var otherDropdownMenus = document.querySelectorAll('.dropdown-menu:not(.show)');
        otherDropdownMenus.forEach(function (menu) {
          menu.style.display = 'none';
        });
        dropdownMenu.style.display = 'block';
        var firstDropdownItem = dropdownMenu.querySelector('.dropdown-item');
        if (firstDropdownItem) {
          firstDropdownItem.focus();
        }
      }
    });
    dropdownMenu.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });
    dropdownMenu.addEventListener('mouseleave', function () {
      hideTimer = setTimeout(function () {
        dropdownMenu.style.display = 'none';
      }, 250);
    });
  }

  var dropdownItems = document.querySelectorAll('.nav-item.dropdown, .dropdown');

  dropdownItems.forEach(function (dropdownItem) {
    handleDropdownHoverAndKeyboard(dropdownItem);
  });
});
// END SECTION FOR DROPDOWN TOOLTIPS

// START SECTION FOR SCROLL TO TOP BUTTON

// var scrollToTopBtn = document.getElementById('scrollToTopBtn');

// // Show/hide the button based on the scroll position
// window.addEventListener('scroll', function () {
//   if (window.pageYOffset > 20) {
//     scrollToTopBtn.style.display = 'block';
//   } else {
//     scrollToTopBtn.style.display = 'none';
//   }
// });

// // Scroll to top when the button is clicked
// scrollToTopBtn.addEventListener('click', function () {
//   window.scrollTo({
//     top: 0,
//     behavior: 'smooth',
//   });
// });

// END SECTION FOR SCROLL TO TOP BUTTON
// START SECTION FOR CALENDAR
let isCalendarInitialized = false;

function initializeCalendar() {
  if (isCalendarInitialized) return;

  var calendarEl = document.getElementById('calendar');
  if (!calendarEl) return; // make sure the element exists

  var dancestyleSlug = calendarEl.dataset.dancestyleSlug;
  var calendar = new FullCalendar.Calendar(calendarEl, {
    // ... your calendar options
  });

  calendar.render();
  isCalendarInitialized = true;
}

// END SECTION FOR CALENDAR
